import { createStore } from "@tredespace/ui/lib";
import type { BuildPlane, PlaneGizmoMode } from "../../engine/planes.ts";

export type PlanesState = Readonly<{
  planes: readonly BuildPlane[];
  selectedId: string | null;
  /** What the gizmo does to the selected plane. */
  mode: PlaneGizmoMode;
  /** Snap moves to 0.1 m, rotation to 15°, size to 0.1 m. */
  snap: boolean;
}>;

export const planesState = createStore<PlanesState>({
  planes: [],
  selectedId: null,
  mode: "move",
  snap: true,
});
